import { DisbursementReasonCategory, RewardReason } from "generated/graphql";
import { disbursementReasonDictionary } from "Shared/types/Disbursements";
import { rewardReasonDictionary } from "Shared/types/Rewards";

export const DISBURSEMENTS_OPTIONS = Object.values(DisbursementReasonCategory).map(value => ({
  value,
  label:
    disbursementReasonDictionary[value],
}));

export const REWARD_REASONS = Object.values(RewardReason).map(value => ({
  value,
  label:
    rewardReasonDictionary[value],
}));
